export const ResourcesResource = {
  name: "Resources",
  path: "/user-management/resources",
  access: ["Resources", "read-resources"],
};
